import { Handle, Position, useNodesData } from "@xyflow/react";
import { usePipelineBuilder } from "V2.0/HomePages/Pipelines/PipelineBuilder/PipelineBuilderProvider";
import {
  Node,
  NodeActions,
  NodeBadge,
  NodeBody,
  NodeHeader,
  NodeName,
} from "./Components/Node";
import ConfigureStepAction from "./Components/ConfigureStepAction";
import DeleteStepAction from "./Components/DeleteStepAction";
import { NodeUIRegistry } from "../Models/nodeUIRegistry";
import { NodeType } from "../Models/NodeType";
import { EndAction, TEndNode, TEndNodeConfig } from "../Models/End";
import NodeExecutionStatusBadge from "./Components/NodeExecutionStatus";
import useNodeExecution from "./Hooks/useNodeExecution";
import usePipelineNode from "./Hooks/usePipelineNode";

export default EndNode;

function EndNode(props) {
  const { id } = props;

  const {
    data,
    onDelete,
    isExecuted,
    internalNode,
    isPanelActive,
    isPreviewMode,
    onConfigureNode,
    executedNodeStatus,
  } = usePipelineNode<TEndNodeConfig>(id);

  const {
    label,
    color,
    icon: Icon,
  } = NodeUIRegistry[NodeType.END][data?.endAction ?? EndAction.NONE];

  return (
    <>
      <Handle
        type="target"
        position={Position.Top}
      />
      <Node status={executedNodeStatus}>
        <NodeHeader>
          <NodeBadge
            color={color}
            label={label}
            icon={<Icon className="size-4" />}
          />
          <NodeActions hideActions={isPanelActive}>
            {(!isPreviewMode || isExecuted) && (
              <ConfigureStepAction
                onConfigureStep={() => onConfigureNode(internalNode)}
              />
            )}
            {!isPreviewMode && (
              <DeleteStepAction onDeleteStep={() => onDelete(internalNode)} />
            )}
          </NodeActions>
        </NodeHeader>
        <NodeBody>
          <NodeName name={data.name} />
          {isExecuted && (
            <NodeExecutionStatusBadge status={executedNodeStatus} />
          )}
        </NodeBody>
      </Node>
    </>
  );
}
